<template>
  <div class="content-main">
    <HeaderBar :text="headerBar.text" :backgroundUrl="headerBar.backgroundUrl"></HeaderBar>

    <div class="content">
      <div class="container">
        <div class="rule">
          <div class="text-center">
            <h1>{{ regulation.main }}</h1>
          </div>
          <div class="detail">
            <p>{{ regulation.detail.text }}</p>
            <a href="#" @click.prevent=""><i class="fa fa-file-text" aria-hidden="true"></i> {{ regulation.detail.download }}</a>
          </div>
        </div>
        <div class="review">
          <div class="text-center">
            <h1>{{ faq.main }}</h1>
          </div>
          <div class="detail question-list">
            <div class="item" v-for="(item, index) in dataSet" :key="index">
              <div class="question" @click="activeAnswer(index)" :class="{active: item.isActive}">{{item.question}} <i class="fa fa-building" aria-hidden="true"></i></div>
              <div class="answer" :class="{active: item.isActive}">{{item.answer}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar.vue'

export default {
  components: {
    HeaderBar
  },
  props: ['headerBar', 'regulation', 'faq', 'dataSet'],
  methods: {
    activeAnswer: function (index) {
      this.dataSet[index].isActive = !this.dataSet[index].isActive
    }
  }
}
</script>

<style scoped>

  .content {
    padding: 60px 0;
  }

  .content .detail {
    padding: 30px 0;
  }

  .detail:first-child a {
    padding: 5px;
    transition: 0.35s;
    border: none;
  }

  .detail a:hover {
    border-bottom: 2px solid #FFA500;
  }

  .question-list {
    margin: 1.25em auto;
    width: 75%;
  }

  .question-list .item {
    margin: 0 0 8px 0;
  }

  .item .question {
    padding: 0.5em 2.2em 0.5em 1.2em;
    margin-bottom: 0px;
    font-weight: 300;
    position: relative;
    display: block;
    width: 100%;
    border: 1px solid rgba(140, 140, 140, 0.3);
    border-radius: 8px;
    transition: 0.35s;
    cursor: pointer;
    font-size: 24px;
    background-color: rgba(194, 194, 194, 0.3);
    user-select: none;
  }

  .item .question .fa-building{
    position: absolute;
    right: 1.2em;
    top: 50%;
    transform: translateY(-50%);
    font-size: 24px;
    visibility: hidden;
    color: #FFA500;
  }

  .item .question.active, .item .question:hover {
    color: #FFA500;
    border-color: #FFA500;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .item .question.active, .item .question:hover .fa-building{
    visibility: visible;
  }

  .item .answer {
    padding: 0px 30px;
    max-height: 0;
    transition: 0.35s;
    overflow: hidden;
    background-color: rgba(255, 163, 51);
    color: #FFF;
  }

  .item .answer.active {
    padding: 30px 30px;
    max-height: 400px;
    border: 1px solid rgba(140, 140, 140, 0.3);
    border-top: none;
  }

  @media screen and (max-width: 991px) {
    .question-list {
      margin: 1.25em auto;
      width: 90%;
    }
  }

  @media screen and (max-width: 480px) {
    .question-list {
      margin: 1.25em auto;
      width: 100%;
    }

    .item .question {
      font-size: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/DORM/Info.vue